import { FC } from 'react';

import { ButtonWithAnalyticEvent } from 'shared/containers/ButtonWithAnalyticEvent';
import { trackOpenFullscreenGallery } from 'shared/store/analytics/actions/trackOpenFullscreenGallery';

import { PhoneButton } from '../../Buttons';

import { IHeaderProps } from './types';

import * as styles from './Header.css';

export const Header: FC<IHeaderProps> = props => {
  const { title, children, onPhoneButtonClick } = props;

  return (
    <div className={styles['container']}>
      {children}
      <div className={styles['title-container']}>{title}</div>
      <div className={styles['buttons']}>
        <ButtonWithAnalyticEvent
          customView={PhoneButton}
          trackAnalyticEvent={trackOpenFullscreenGallery}
          onClick={onPhoneButtonClick}
        >
          Показать контакты
        </ButtonWithAnalyticEvent>
      </div>
    </div>
  );
};

Header.displayName = 'Header';
